/**
 * Login page bundle. Wires the "Sign in with Google" button (no-ops when the button isn't rendered,
 * e.g. no client id configured) and the Phone/Email toggle. Per-page bundle, fireball-style — there is
 * no global framework bundle.
 */
import { AppleSignIn } from '../components/auth/appleSignIn';
import { GoogleSignIn } from '../components/auth/googleSignIn';
import { LoginToggle } from '../components/auth/loginToggle';
import { PhoneMask } from '../components/auth/phoneMask';
GoogleSignIn.init();
AppleSignIn.init();
LoginToggle.init();
PhoneMask.init();
